rdefine('app/stores/hours',['backbone','text!stores/hours.html','app/stores/hoursModal'],function(Backbone,template, HoursModal) {

    var timeMainView = Backbone.Ribs.View.extend({
        tagName:'li',
        bindings:{
            el:{
                text:{
                    data:['model.ftime','model.stime'],
                    processor:function(f,s) {
                        if(f===s && f === "00:00") {
                            return window.LANGUAGE['stores.hours.24'];
                        }
                        return f + ' - ' + s;
                    }
                }
            }
        }
    });

    var colTimes = Backbone.Ribs.Collection.extend({
        model:Backbone.Ribs.Model,
        inside: null,
        myKey: null,
        initialize:function(els,options) {
            this.inside = options.inside;
            this.myKey = options.key;

            var e = this.inside.get(this.myKey);
            if(e && e.times) {
                this.reset(e.times);
            }else{
                this.inside.set(this.myKey+".times",[]);
            }

            this.inside.on("change:"+this.myKey+".times",function() {
                var e = this.inside.get(this.myKey);
                if(e && e.times) {
                    this.reset(e.times);
                }
            }.bind(this));

            this.on("add remove reset",this.pack.bind(this));
        },
        pack:function() {
            this.inside.set(this.myKey+".times",this.models);
        }
    });

    var HoursModel = Backbone.Ribs.Model.extend({
        defaults:{
            monday:{
                enabled:false,
                times:[]
            },
            tuesday:{
                enabled:false,
                times:[]
            },
            wednesday:{
                enabled:false,
                times:[]
            },
            thursday:{
                enabled:false,
                times:[]
            },
            friday:{
                enabled:false,
                times:[]
            },
            saturday:{
                enabled:false,
                times:[]
            },
            sunday:{
                enabled:false,
                times:[]
            }
        }
    });

    return Backbone.Ribs.View.extend({
        className:'hours-place',
        input:null,
        cMonday:null,
        cTuesday:null,
        cWednesday:null,
        cThursady:null,
        cFriday:null,
        cSaursday:null,
        cSunday:null,
        bindings:{
            '.c-monday .on-off':{
                toggle:{
                    data:'model.monday.enabled',
                    processor:function(a){return !a;}
                }
            },
            '.c-tuesday .on-off':{
                toggle:{
                    data:'model.tuesday.enabled',
                    processor:function(a){return !a;}
                }
            },
            '.c-wednesday .on-off':{
                toggle:{
                    data:'model.wednesday.enabled',
                    processor:function(a){return !a;}
                }
            },
            '.c-thurday .on-off':{
                toggle:{
                    data:'model.thursday.enabled',
                    processor:function(a){return !a;}
                }
            },
            '.c-friday .on-off':{
                toggle:{
                    data:'model.friday.enabled',
                    processor:function(a){return !a;}
                }
            },
            '.c-saturday .on-off':{
                toggle:{
                    data:'model.saturday.enabled',
                    processor:function(a){return !a;}
                }
            },
            '.c-sunday .on-off':{
                toggle:{
                    data:'model.sunday.enabled',
                    processor:function(a){return !a;}
                }
            },
            '.c-monday .hours-list':{
                collection:{
                    col:'cMonday',
                    view:timeMainView
                },
                toggle:{
                    data:'model.monday.enabled'
                }
            },
            '.c-tuesday .hours-list':{
                collection:{
                    col:'cTuesday',
                    view:timeMainView
                },
                toggle:{
                    data:'model.tuesday.enabled'
                }
            },
            '.c-wednesday .hours-list':{
                collection:{
                    col:'cWednesday',
                    view:timeMainView
                },
                toggle:{
                    data:'model.wednesday.enabled'
                }
            },
            '.c-thurday .hours-list':{
                collection:{
                    col:'cThursady',
                    view:timeMainView
                },
                toggle:{
                    data:'model.thursday.enabled'
                }
            },
            '.c-friday .hours-list':{
                collection:{
                    col:'cFriday',
                    view:timeMainView
                },
                toggle:{
                    data:'model.friday.enabled'
                }
            },
            '.c-saturday .hours-list':{
                collection:{
                    col:'cSaursday',
                    view:timeMainView
                },
                toggle:{
                    data:'model.saturday.enabled'
                }
            },
            '.c-sunday  .hours-list':{
                collection:{
                    col:'cSunday',
                    view:timeMainView
                },
                toggle:{
                    data:'model.sunday.enabled'
                }
            }
        },
        events:{
            "click .hover-content":"openModal"
        },
        initialize:function(options) {
            this.$el.html(Template7.compile(template)());
            this.input = options.input;
            this.model = new HoursModel();
            this.unpackInput();
            this.cMonday = new colTimes(this.model.attributes.monday.times ? this.model.attributes.monday.times : [],{inside:this.model,key:'monday'});
            this.cTuesday = new colTimes(this.model.attributes.tuesday.times ? this.model.attributes.tuesday.times : [],{inside:this.model,key:'tuesday'});
            this.cWednesday = new colTimes(this.model.attributes.wednesday.times ? this.model.attributes.wednesday.times : [],{inside:this.model,key:'wednesday'});
            this.cThursady = new colTimes(this.model.attributes.thursday.times ? this.model.attributes.thursday.times : [],{inside:this.model,key:'thursday'});
            this.cFriday = new colTimes(this.model.attributes.friday.times ? this.model.attributes.friday.times : [],{inside:this.model,key:'friday'});
            this.cSaursday = new colTimes(this.model.attributes.saturday.times ? this.model.attributes.saturday.times : [],{inside:this.model,key:'saturday'});
            this.cSunday = new colTimes(this.model.attributes.sunday.times ? this.model.attributes.sunday.times : [],{inside:this.model,key:'sunday'});
            this.model.on("change save",this.packInput.bind(this));

            this.modal=new ModalWrapper({
                content:HoursModal,
                title:window.LANGUAGE['stores.hours'],
                config:{
                    model:this.model,
                    controller:this
                },
                buttons:[
                    {
                        'id':'save',
                        title:window.LANGUAGE['statistics.modal.close'],
                        style:'btn-primary',
                        cbs:[],
                        event:'close'
                    }
                ]
            });
        },
        packInput:function(){

            var pack = {
                monday:{
                    enabled:this.model.get("monday.enabled"),
                    times:_.map(this.model.get("monday.times"),function(i){return i.attributes ? i.attributes : i;})
                },
                tuesday:{
                    enabled:this.model.get("tuesday.enabled"),
                    times:_.map(this.model.get("tuesday.times"),function(i){return i.attributes ? i.attributes : i;})
                },
                wednesday:{
                    enabled:this.model.get("wednesday.enabled"),
                    times:_.map(this.model.get("wednesday.times"),function(i){return i.attributes ? i.attributes : i;})
                },
                thursday:{
                    enabled:this.model.get("thursday.enabled"),
                    times:_.map(this.model.get("thursday.times"),function(i){return i.attributes ? i.attributes : i;})
                },
                friday:{
                    enabled:this.model.get("friday.enabled"),
                    times:_.map(this.model.get("friday.times"),function(i){return i.attributes ? i.attributes : i;})
                },
                saturday:{
                    enabled:this.model.get("saturday.enabled"),
                    times:_.map(this.model.get("saturday.times"),function(i){return i.attributes ? i.attributes : i;})
                },
                sunday:{
                    enabled:this.model.get("sunday.enabled"),
                    times:_.map(this.model.get("sunday.times"),function(i){return i.attributes ? i.attributes : i;})
                }
            };
            console.log("packed",pack);
            this.input.val(JSON.stringify(pack));
        },
        unpackInput:function(){
            try {
                $j = JSON.parse(this.input.val());
                if($j) {
                    this.model.set($j);
                }else{
                 this.model.set({
                     monday:{
                         enabled:false,
                         times:[]
                     },
                     tuesday:{
                         enabled:false,
                         times:[]
                     },
                     wednesday:{
                         enabled:false,
                         times:[]
                     },
                     thursday:{
                         enabled:false,
                         times:[]
                     },
                     friday:{
                         enabled:false,
                         times:[]
                     },
                     saturday:{
                         enabled:false,
                         times:[]
                     },
                     sunday:{
                         enabled:false,
                         times:[]
                     }
                 });
                }
            } catch (e) {
                this.model.set({
                    monday:{
                        enabled:false,
                        times:[]
                    },
                    tuesday:{
                        enabled:false,
                        times:[]
                    },
                    wednesday:{
                        enabled:false,
                        times:[]
                    },
                    thursday:{
                        enabled:false,
                        times:[]
                    },
                    friday:{
                        enabled:false,
                        times:[]
                    },
                    saturday:{
                        enabled:false,
                        times:[]
                    },
                    sunday:{
                        enabled:false,
                        times:[]
                    }
                });
            }
        },
        openModal:function(){

           this.modal.show();
        }
    });
});